import { authorizedAPI } from '@/config/axios.config';
import { UtilsService } from '@/services/utils/utils.service';

const utils = new UtilsService();
import type { CompanyMembership } from '@/types/user.types';

export interface SwitchCompanyResponse {
  success: boolean;
  company: {
    id: string;
    name: string;
    address?: string;
    website?: string;
    phone?: string;
    ownerId: string;
    createdAt: string;
    updatedAt: string;
  };
  membership: CompanyMembership;
}

export interface CanLeaveCompanyResponse {
  canLeave: boolean;
  reason?: string;
}

export interface TransferOwnershipResponse {
  success: boolean;
}

class CompanyMembershipService {
  async getUserMemberships(): Promise<CompanyMembership[]> {
    return utils.handleApiRequest<CompanyMembership[]>(() =>
      authorizedAPI.get('/company-membership')
    );
  }

  async switchCompany(companyId: string): Promise<SwitchCompanyResponse> {
    return utils.handleApiRequest<SwitchCompanyResponse>(() =>
      authorizedAPI.post('/company-membership/switch', { companyId })
    );
  }

  async leaveCompany(companyId: string): Promise<{ success: boolean }> {
    return utils.handleApiRequest<{ success: boolean }>(() =>
      authorizedAPI.delete(`/company-membership/${companyId}`)
    );
  }

  async transferOwnership(companyId: string, newOwnerId: string): Promise<TransferOwnershipResponse> {
    return utils.handleApiRequest<TransferOwnershipResponse>(() =>
      authorizedAPI.post('/company-membership/transfer-ownership', {
        companyId,
        newOwnerId,
      })
    );
  }

  async canLeaveCompany(companyId: string): Promise<CanLeaveCompanyResponse> {
    return utils.handleApiRequest<CanLeaveCompanyResponse>(() =>
      authorizedAPI.get(`/company-membership/${companyId}/can-leave`)
    );
  }
}

export const companyMembershipService = new CompanyMembershipService();

